export enum ConfigurationNavItem {
  Configuration = "NAVIGATION.CONFIGURATION",
  ApproverGroup = "NAVIGATION.APPROVERGROUP",
  Picklist = "NAVIGATION.PICKLIST",
  CompetenceManager = "NAVIGATION.COMPETENCE_MANAGER",
  PermitAdmin = "NAVIGATION.PERMITADMIN",
  VideoAdmin = "NAVIGATION.VIDEOADMIN",
}
